module.exports = __webpack_public_path__ + "img/Logo-motoE-tm.38140b01.svg";